module.exports = __webpack_public_path__ + "img/kakaotalk.1808002d.svg";